import { resolveOaiAdsPixelId } from "@/lib/analytics/oai-config";

/**
 * Public values for browser code, inlined at build time. `src/env.ts`
 * validates the same variables on the server; browser code reads them here
 * so the validation library stays out of the page bundle.
 */
export const clientEnv = {
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  NEXT_PUBLIC_ANALYTICS_INGEST_URL: process.env.NEXT_PUBLIC_ANALYTICS_INGEST_URL,
  NEXT_PUBLIC_OAI_ADS_PIXEL_ID: resolveOaiAdsPixelId(process.env.NEXT_PUBLIC_OAI_ADS_PIXEL_ID),
};
